import React from 'react';
import {
	GRID_CHECKBOX_SELECTION_FIELD,
	gridFilteredSortedRowIdsSelector,
	useGridApiContext,
	useGridSelector,
} from '@mui/x-data-grid';
import { ExportCsvButton } from '@/components/tables/export/ExportCsvButton';
import { downloadCsv } from '@/components/tables/export/downloadCsv';

/**
 * Export for admin browser lists, for AdminDataGrid's toolbarActions. Exports what the grid
 * holds after the page's filters, search and sort, across every page, as
 * `<fileName>_Data_Extract.csv`. Only the visible columns, in their current order, with
 * each cell's formatted value (the column's valueFormatter), so the file reads like the
 * table. For a list paged on the server the grid only holds the current page, so that list
 * needs its own export that fetches every row.
 */
export const AdminExportButton = ({ fileName }) => {
	const apiRef = useGridApiContext();
	const rowIds = useGridSelector(apiRef, gridFilteredSortedRowIdsSelector);

	const handleExport = () =>
		downloadCsv({
			columns: apiRef.current
				.getVisibleColumns()
				.filter((column) => column.field !== GRID_CHECKBOX_SELECTION_FIELD),
			rows: rowIds.map((id) => apiRef.current.getRow(id)),
			getValue: (column, row) => apiRef.current.getRowFormattedValue(row, column),
			fileName,
		});

	return <ExportCsvButton onExport={handleExport} disabled={!rowIds.length} />;
};
